module.exports = new __parcel__URL__("john-wick-chapter-4.b03a2d44.jpg").toString();